<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>menu</ion-title>
  </ion-toolbar>
</ion-header> -->

<ion-header [translucent]="true">
  <ion-toolbar>
      <ion-title>StcDataEntry</ion-title>
      <ion-buttons slot="end">
        <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title> -->
        <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title style="cursor: pointer;" size="large">menu</ion-title>
    </ion-toolbar>
  </ion-header>


  <ion-grid *ngIf="userRole != 'test'">
    <ion-row>
      
      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToDataCreation()">
          <ion-card-header>
            <ion-card-title  size="large">Data Creation Home</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to create data.
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToHistoryPage()">
          <ion-card-header>
            <ion-card-title  size="large">My History</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to see saved data.
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToAllHistory()">
          <ion-card-header>
            <ion-card-title  size="large">All History</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to see all user's saved data.
          </ion-card-content>
        </ion-card>
      </ion-col>
      
    </ion-row>

    <ion-row>
      
      

      <!-- <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToAddTextAndSound()">
          <ion-card-header>
            <ion-card-title size="large">Add Sound Text</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to add sound and text in datacreation tool.
          </ion-card-content>
        </ion-card>
      </ion-col> -->

      <!-- <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToHistoryPage()">
          <ion-card-header>
            <ion-card-title size="large">My History</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to see saved data.
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" size-md="4">
        <ion-card [style.visibility]="isAuthenticated ? 'visible' : 'hidden'" (click)="goToAllHistory()">
          <ion-card-header>
            <ion-card-title>All History</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to inference model.
          </ion-card-content>
        </ion-card>
      </ion-col> -->

      <!-- <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;"  (click)="goToAddSoundAndText()">
          <ion-card-header>
            <ion-card-title size="large">Add Sound and Text</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to add soundfile with text in Datacreation Tool.
          </ion-card-content>
        </ion-card>
      </ion-col> -->

      <!-- <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" [style.visibility]="isAuthenticated ? 'visible' : 'hidden'" (click)="goToModelInferencing()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Model Inferencing</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to inference model.
          </ion-card-content>
        </ion-card>
      </ion-col> -->

      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToModelInferencing()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Model Inferencing</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to inference model.
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToSentimentAnalysis()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Sentiment Analysis</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here for sentiment analysis.
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToSTTAnalysis()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">STT Analysis</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here for stt analysis.
          </ion-card-content>
        </ion-card>
      </ion-col>


      <!-- <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToTextList()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Text List</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here to see the list.
          </ion-card-content>
        </ion-card>
      </ion-col> -->
      
    </ion-row>
    <ion-row>
    
      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToClassificationAnalysis()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Classification Analysis</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here for stt analysis.
          </ion-card-content>
        </ion-card>
      </ion-col>

    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="userRole == 'test'">
    <ion-row>

      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToSTTAnalysis()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">STT Analysis</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here for stt analysis.
          </ion-card-content>
        </ion-card>
      </ion-col>
    
      <ion-col size="6" size-md="4">
        <ion-card style="cursor: pointer;" (click)="goToClassificationAnalysis()">
          <ion-card-header>
            <ion-card-title style="cursor: pointer;" size="large">Classification Analysis</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            Click here for stt analysis.
          </ion-card-content>
        </ion-card>
      </ion-col>

    </ion-row>
  </ion-grid>
</ion-content>
